document.addEventListener('DOMContentLoaded', function () {
  console.log("✅ Combo product script loaded");

  let comboVariantIds = [];

  const script = document.getElementById('combo-product-data');
  if (script) {
    try {
      const value = JSON.parse(script.textContent.trim());
      if (Array.isArray(value)) {
        comboVariantIds = value.map(v => parseInt(v.id)).filter(id => !isNaN(id));
        console.log("✅ Combo Variant IDs:", comboVariantIds);
      }
    } catch (e) {
      console.error("❌ Failed to parse combo product metafield JSON:", e);
    }
  }

  function showToast(message) {
    let toast = document.createElement('div');
    toast.id = 'combo-toast';
    toast.style.position = 'fixed';
    toast.style.top = '20px';
    toast.style.right = '20px';
    toast.style.background = '#111';
    toast.style.color = '#fff';
    toast.style.padding = '12px 20px';
    toast.style.borderRadius = '10px';
    toast.style.zIndex = 9999;
    toast.style.boxShadow = '0 2px 6px rgba(0,0,0,0.2)';
    toast.style.fontSize = '14px';
    toast.innerText = message;

    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 3000);
  }

  const forms = document.querySelectorAll('form[action="/cart/add"]');
  forms.forEach(form => {
    // Prevent default form submission permanently
    form.addEventListener('submit', async function (e) {
      e.preventDefault();
      console.log("🛒 Intercepted Add to Cart");

      const formData = new FormData(form);
      const mainVariantId = formData.get('id');
      const mainQty = parseInt(formData.get('quantity')) || 1;

      const items = [{ id: mainVariantId, quantity: mainQty }];

      for (const comboId of comboVariantIds) {
        items.push({ id: comboId, quantity: 1 });
      }

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ items }),
          credentials: 'same-origin'
        });

        if (res.ok) {
          const result = await res.json();
          console.log("🎉 Added to cart:", result);
          showToast("Main + combo products added!");

          // Optional: redirect immediately to cart to avoid confusion
         // window.location.href = '/cart';
        } else {
          const err = await res.json();
          throw new Error(err.description || 'Add to cart failed');
        }
      } catch (err) {
        console.error("❌ Failed to add items to cart:", err);
        showToast("Error adding combo items.");
      }
    });
  });
});
